export class UICursorAsset
{
  #name:string;
  #x:number;
  #y:number;

  get name():string
  {
    return this.#name;
  }

  get fileName():string
  {
    return `mouse--cursor--${this.#name}.png`;
  }

  get rootPath():string
  {
    return UICursors.rootPath + this.fileName;
  }

  get url():string
  {
    return new URL( this.rootPath, window.location.origin ).toString();
  }

  get css():string
  {
    return `url("${this.url}") ${this.#x} ${this.#y}, auto`;
  }

  toString():string
  {
    return this.css;
  }

  static create( name:string, x:number = 0, y:number = 0 )
  {
    let asset = new UICursorAsset();
    asset.#name = name;
    asset.#x = x;
    asset.#y = y;

    return asset;
  }
}

export class UICursors
{
  static readonly rootPath = "_media/general--graphics/";

  static readonly default  = UICursorAsset.create( "default" );
  static readonly dragging = UICursorAsset.create( "dragging", 16, 16 );
  static readonly releaseDragging = UICursorAsset.create( "release--dragging", 16, 16 );
}